import { i18n } from '@fs/zion-locale'
import { baseUrl } from '@fs/zion-config'

import { cleanUpNotes, findPropertyValue } from 'helpers'
import { formattedYearRange } from 'helpers/dateUtils'
import DownloadCsvConfig from './DownloadCsvConfig'

export default class JiapuCsv extends DownloadCsvConfig {
  static columns = [
    { key: 'title', header: i18n.t('JiapuCsv.header.title', 'Title') },
    { key: 'titleNumber', header: i18n.t('JiapuCsv.header.titleNumber', 'Title Number') },
    { key: 'groupId', header: i18n.t('JiapuCsv.header.groupId', 'Group ID') },
    { key: 'surnames', header: i18n.t('JiapuCsv.header.surname', 'Surname') },
    { key: 'places', header: i18n.t('JiapuCsv.header.place', 'Place') },
    { key: 'date', header: i18n.t('JiapuCsv.header.date', 'Date') },
    { key: 'publicationDate', header: i18n.t('JiapuCsv.header.publicationDate', 'Publication Date') },
    { key: 'volumeCount', header: i18n.t('JiapuCsv.header.volumeCount', 'Volume Count') },
    { key: 'volumes', header: i18n.t('JiapuCsv.header.volume', 'Volume') },
    { key: 'imageCount', header: i18n.t('JiapuCsv.header.imageCount', 'Image Count') },
    { key: 'ancestors', header: i18n.t('JiapuCsv.header.ancestors', 'First Ancestors') },
    { key: 'ancestralHall', header: i18n.t('JiapuCsv.header.ancestralHall', 'Ancestral Hall') },
    { key: 'authors', header: i18n.t('JiapuCsv.header.author', 'Author') },
    { key: 'titleNotes', header: i18n.t('JiapuCsv.header.notes', 'Notes') },
    { key: 'generationPoem', header: i18n.t('JiapuCsv.header.generationPoem', 'Generation Poem') },
    { key: 'url', header: i18n.t('JiapuCsv.header.url', 'URL') },
  ]

  static filename = i18n.t('JiapuCsv.filename.searchResults', 'searchResults')

  generateRows(groups) {
    groups.forEach((group) => {
      this.rows.push({
        ancestors: group.ancestors?.join(', '),
        ancestralHall: group.ancestralHall,
        authors: group.authors?.join(', '),
        date: formattedYearRange([group.yearRange?.fromYear, group.yearRange?.toYear]),
        generationPoem: group.generationPoem,
        groupId: group.id,
        imageCount: group.childCount,
        places: [...new Set(group.coverages?.map((coverage) => coverage.place?.fullName))].filter(Boolean).join('; '),
        publicationDate: group.publicationDate,
        surnames: group.surnames?.join(', '),
        title: group.volumeSetTitle,
        titleNotes: cleanUpNotes(group.titleNotes).join(', '),
        titleNumber: group.titleNumber,
        url: `${baseUrl}/records/images/redirect/${group.id}`,
        volumes: findPropertyValue('volume', group.properties),
        volumeCount: group.childGroupCount,
      })
    })
  }
}
